import React, { Component } from "react";
import PropTypes from "prop-types";
import EventSubList from "./EventSubList";
import PreviewableImage from "../common/PreviewableImage";
import { l10n } from "../../common/constants";
import { getPluginKey, PLUGIN_SERAGAM } from "../form-builder/schemaRuntime";

const seragamExclusives = Array.from(
    { length: 20 },
    (_, index) => `seragam${index + 1}`
);

export class EventItem extends Component {
    state = {
        selectedDate: 0,
    };

  render() {
    // eslint-disable-next-line
    const { code, name, image_url, exclusive } = this.props.event;
    const language = this.props.language || "ind";
    const fullImageUrl = image_url
      ? (image_url.startsWith('http') ? image_url : `${process.env.REACT_APP_IMAGES_URL}${image_url}`)
      : null;
    const excludedExclusives = [
      "christmas2025",
      "christmascelebration1",
      "christmascelebration2",
      "christmascelebration3",
      "christmascelebration4",
      "christmascelebration5",
      "christmascelebrationforvip1",
      "christmascelebrationforvip2",
      "christmascelebrationforvip3",
      "christmascelebrationforvip4",
      "christmascelebrationforvip5",
    ];
    const isSeragamEvent =
      seragamExclusives.includes(exclusive) ||
      getPluginKey(this.props.event) === PLUGIN_SERAGAM;
    return (
      <div className="row" style={eventItemStyle}>
        <div className="col-sm-8 col-12" style={{ paddingBottom: '0px' }}>
          {/* Image Banner */}
          {fullImageUrl && (
            <PreviewableImage
              buttonClassName="event-item__banner-button"
              hintText={l10n.previewImageHint[language]}
              imageClassName={`img-fluid shadow ${isSeragamEvent ? "event-item__banner--seragam" : ""}`}
              imageStyle={imageStyle}
              previewTitle={name}
              resetText={l10n.reset[language]}
              src={fullImageUrl}
              alt={name}
              zoomLabel={l10n.previewZoom[language]}
            />
          )}

          {this.props.event.uniqueDates.map((_, index) => (
            <div
              key={index}
              style={divStyle}
              className={isSeragamEvent ? "event-item__section--seragam" : ""}
            >
              {!excludedExclusives.includes(exclusive) && (
                isSeragamEvent ? (
                  index === 0 && (
                    <div className="event-item__seragam-header">
                      <div className="event-item__seragam-eyebrow">{l10n.seragamPurchase[language]}</div>
                      <p style={titleStyle} className="event-item__seragam-title">{name}</p>
                      <p className="event-item__seragam-caption">
                        {l10n.seragamPurchaseCaption[language]}
                      </p>
                    </div>
                  )
                ) : (
                  <p style={titleStyle}>{name}</p>
                )
              )}
              <div className={`row ${isSeragamEvent ? "event-item__seragam-list" : ""}`} style={eventSubStyle}>
                <EventSubList
                  event={this.props.event}
                  language={language}
                  selectedDate={index}
                  selectEvent={this.props.selectEvent}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
    }
}

// PropTypes
EventItem.propTypes = {
    event: PropTypes.object.isRequired,
    language: PropTypes.string,
    selectEvent: PropTypes.func.isRequired,
};

// Styles
const divStyle = {
  marginLeft: '0%',
  marginBottom: '25px',
};

const imageStyle = {
    borderRadius: "10px",
};

const titleStyle = {
  fontWeight: 'bold',
  marginBottom: '12px',
  marginLeft: '0%',
  fontSize: '1.5rem',
};
// const selectDateStyle = {
//   width: '85%',
//   fontSize: '1.00rem',
//   border: 'none',
//   paddingBottom: '4px',
//   marginTop: '5px',
//   marginLeft: '5px',
//   borderBottom: '1px solid #ccc',
//   backgroundColor: 'transparent',
// };

const eventSubStyle = {
  width: '100%',
  marginLeft: '0%',
  marginTop: '5px',
};

const eventItemStyle = {
    justifyContent: "center",
    marginBottom: "5px",
};
export default EventItem;
